import { Box, Text } from '@domain-group/suit-theme'

import { stringHasContent } from '@functions/utility'

interface AdCopyProps {
  description?: string,
  tagline?: string,
}

const AdCopy = (props: AdCopyProps) => {
  const { description, tagline } = props

  return (
    <Box flexDirection="column" padding="large">
      {stringHasContent(tagline) && (
        <>
          <Text color="bodyFontLightColor" fontSize="xsmall">Tagline</Text>

          <Text
            color="bodyFontColor"
            fontSize="small"
            lineHeight={1.5}
            marginTop="medium"
          >
            {tagline}
          </Text>
        </>
      )}

      {stringHasContent(description) && (
        <>
          <Text
            color="bodyFontLightColor"
            fontSize="xsmall"
            marginTop={stringHasContent(tagline) ? 'large' : null}
          >
            Description
          </Text>

          <Text
            color="bodyFontColor"
            fontSize="small"
            lineHeight={1.5}
            marginTop="medium"
          >
            {description}
          </Text>
        </>
      )}
    </Box>
  )
}

export default AdCopy
